import { Controller, useFormContext } from 'react-hook-form';

import type { DateRangePreset } from '~shared/ui/date-range-picker';
import { DateRangePicker } from '~shared/ui/date-range-picker';

import { endOfDay, startOfDay, subDays } from 'date-fns';

import {
  MAX_ORDERS_PERIOD_DAYS,
  type OrdersFiltersValue,
} from '../../model/orders-filters';

const PERIOD_PRESETS: DateRangePreset[] = [7, 14, 30].map((days) => ({
  title: `Last ${days} days`,
  value: {
    startDate: startOfDay(subDays(new Date(), days)).toISOString(),
    endDate: endOfDay(new Date()).toISOString(),
  },
}));

type Props = {
  onChange?: () => void;
};

export function OrdersPeriodFilter({ onChange }: Props) {
  const { control } = useFormContext<OrdersFiltersValue>();

  return (
    <Controller
      control={control}
      name="period"
      render={({ field, ...controllerProps }) => (
        <DateRangePicker
          {...controllerProps}
          field={{
            ...field,
            onChange: (period: OrdersFiltersValue['period']) => {
              field.onChange(period);

              const isComplete = Boolean(period.startDate && period.endDate);
              const isCleared = !period.startDate && !period.endDate;

              if (isComplete || isCleared) {
                onChange?.();
              }
            },
          }}
          align="end"
          minDate={startOfDay(subDays(new Date(), MAX_ORDERS_PERIOD_DAYS))}
          maxDate={endOfDay(new Date())}
          presets={PERIOD_PRESETS}
        />
      )}
    />
  );
}
